/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import config from '../../config/config.json';
import Head from '../Head';
import { UserLogin } from '../Login/UserLogin';
import { HowItWorks } from './HowItWorks';

export const Login = () => {
  const { t } = useTranslation('dbd', { keyPrefix: 'dbd' });
  const { globalContent } = config;

  const keyart = '/static/images/games/dbd/dbd-keyart-alt.jpg';
  const keyartDesktop = '/static/images/games/dbd/dbd-keyart.jpg';

  return (
    <>
      <Head />
      <div className={classNames('relative flex w-full flex-col bg-black')}>
        {/* Mobile background */}
        <img
          src={keyart}
          alt=''
          role='presentation'
          className={classNames(
            'absolute top-0 right-0 left-0 w-full',
            'h-[18.125rem] sm:h-[28.125rem]',
            'object-cover',
            'pointer-events-none',
            'lg:hidden',
          )}
        />
        <div
          className={classNames(
            'absolute right-0 bottom-0 left-0 z-1',
            'top-[16.25rem] h-[1.875rem] sm:top-[26.25rem]',
            'bg-gradient-to-t from-black via-black/80 to-transparent',
            'lg:hidden',
          )}
        />

        {/* Desktop background */}
        <img
          src={keyartDesktop}
          alt=''
          role='presentation'
          className={classNames(
            'absolute top-0 right-0',
            'min-h-[56.25rem]',
            'object-cover opacity-80',
            'pointer-events-none',
            'hidden lg:block',
          )}
        />

        <div className={classNames('z-1 px-6 py-20 sm:px-20 sm:pt-[20rem]')}>
          <div className={classNames('flex w-full flex-col sm:max-w-[30rem]')}>
            <img
              src={globalContent.logo}
              alt={globalContent.title}
              className='m-auto mb-40 h-auto w-56 max-w-[21rem] sm:m-0 sm:mb-10 sm:w-[30rem]'
            />
            <h1 className='mb-0 font-display text-display-md text-neutral-text-xlight'>{t('landing.title')}</h1>
            <p className='font-sans text-md text-neutral-text-light'>{t('landing.description')}</p>
            <UserLogin />
            <p className='mt-3 font-sans text-sm text-neutral-text-light'>{t('landing.helper')}</p>
            <HowItWorks className='mt-10' />
          </div>
        </div>
      </div>
    </>
  );
};
